module.exports = __webpack_public_path__ + "static/media/communitysocial-icon.70ea7378.jpg";